import Swal from "sweetalert2/dist/sweetalert2.js";
import Vue from "vue";

let disabledAlertOption = {
  showConfirmButton: false,
  timerProgressBar: false,
  showLoaderOnConfirm: false,
  allowOutsideClick: false,
  showLoading: false,
  customClass: {
    title: "alertTitleClass",
  },
};

function paymentIdNotValidAlert() {
  return Swal.fire({
    title: Vue.prototype.$translate("attention"),
    text: Vue.prototype.$translate("requestedTransactionIsInvalid"),
    icon: "error",
    showConfirmButton: false,
    timerProgressBar: false,
    showLoaderOnConfirm: false,
    allowOutsideClick: false,
    showLoading: false,
    customClass: {
      title: "alertTitleClass",
    },
  });
}

function shetabStartingAlert() {
  return Swal.fire({
    title: Vue.prototype.$translate("attention"),
    text: Vue.prototype.$translate("shetabAlertInfo"),
    icon: "success",
    showConfirmButton: true,
    timerProgressBar: true,
    showLoaderOnConfirm: true,
    showLoading: true,
    timer: 10000,
    showClass: {
      popup: "animate__animated animate__fadeIn",
    },
    // hideClass: {
    //   popup: 'animate__animated animate__fadeOut'
    // },
    confirmButtonText: Vue.prototype.$translate("IUnderstand"),
    customClass: {
      title: "alertTitleClass",
    },
  });
}

function transactionSuccessAlert(title = "", text = "", timer = 1000) {
  return Swal.fire({
    position: "center",
    title: title,
    text: text,
    timer: timer,
    icon: "success",
    showConfirmButton: false,
    timerProgressBar: true,
    allowOutsideClick: false,
  });
}
function transactionNotValidAlert() {
  return Swal.fire({
    title: Vue.prototype.$translate("attention"),
    text: Vue.prototype.$translate("requestedTransactionIsInvalid"),
    icon: "error",
    ...disabledAlertOption,
  });
}
function systemErrorAlert() {
  return Swal.fire({
    title: Vue.prototype.$translate("systemError"),
    text: Vue.prototype.$translate("tryThePaymentStepsAgain"),
    icon: "error",
    ...disabledAlertOption,
  });
}

function fatalErrorAlert(
  title = Vue.prototype.$translate("systemError"),
  text = Vue.prototype.$translate("connectionToServerIsNotEstablishedTryAgain"),
  position = "center"
) {
  return Swal.fire({
    position: position,
    title: title,
    text: text,
    icon: "error",
    ...disabledAlertOption,
  });
}
function hardErrorAlert(
  title = Vue.prototype.$translate("changeIpAlertError"),
  text = "",
  timer = 10000,
  confirmButtonText = Vue.prototype.$translate("IUnderstand"),
  addPostfix = true
) {
  let alertText =
    text.length === 0
      ? Vue.prototype.$translate("ipChangeDuringPaymentAndBankNotResponding")
      : text;
  const fixErrorMessage = `"<strong>${Vue.prototype.$translate(
    "tryYourPaymentWithADifferentSwitch"
  )}</strong>"`;
  return Swal.fire({
    position: "center",
    title: title,
    html: addPostfix ? alertText + ", " + fixErrorMessage : alertText,
    timer: timer,
    confirmButtonText: confirmButtonText,
    icon: "error",
    showConfirmButton: true,
    allowOutsideClick: false,
  });
}
function apiErrorAlert(
  title = Vue.prototype.$translate("changeIpAlertError"),
  text = "",
  timer = 10000,
  confirmButtonText = Vue.prototype.$translate("IUnderstand")
) {
  let alertText =
    text.length === 0
      ? Vue.prototype.$translate("ipChangeDuringPaymentAndBankNotResponding")
      : text;
  // const fixErrorMessage =
  //   "لطفا پرداخت خود را با سوییچ دیگری که به آن هدایت می شوید، امتحان کنید";
  return Swal.fire({
    position: "center",
    title: title,
    text: alertText,
    timer: timer,
    confirmButtonText: confirmButtonText,
    icon: "error",
    showConfirmButton: true,
  });
}
function requestPinCodeErrorAlert(
  title = Vue.prototype.$translate("changeIpAlertError"),

  text = "",
  timer = 10000,
  confirmButtonText = Vue.prototype.$translate("IUnderstand"),
  cancelButtonText = Vue.prototype.$translate("cancel")
) {
  let alertText =
    text.length === 0
      ? Vue.prototype.$translate("ipChangeDuringPaymentAndBankNotResponding")
      : text;

  return Swal.fire({
    position: "center",
    title: title,
    text: alertText,
    timer: timer,
    confirmButtonText: confirmButtonText,
    cancelButtonText: cancelButtonText,
    icon: "error",
    showConfirmButton: true,
    showCancelButton: true, // Show the cancel button
  });
}

function infoAlert(title = "", text = "", position = "center", timer = 2000) {
  return Swal.fire({
    position: position,
    title: title,
    text: text,
    timer: timer,
    icon: "info",
    showConfirmButton: false,
  });
}
function errorAlert(title = "", text = "", timer = 2000) {
  return Swal.fire({
    position: "center",
    title: title,
    text: text,
    timer: timer,
    icon: "error",
    showConfirmButton: false,
  });
}
function warningAlert(
  title = "",
  text = "",
  confirmButtonText = "",
  cancelButtonText = ""
) {
  return Swal.fire({
    position: "center",
    title: title,
    text: text,
    icon: "warning",
    showConfirmButton: true,
    showCancelButton: true,
    confirmButtonText: confirmButtonText,
    cancelButtonText: cancelButtonText,
    confirmButtonColor: "var(--dodger-blue)",
    cancelButtonColor: "var(--light-red)",
    customClass: {
      confirmButton: "warning-alert-confirm-button ",
      cancelButton: "warning-alert-confirm-button ",
    },
  });
}

function loadingAlert(title = Vue.prototype.$translate("pleaseWait")) {
  Swal.fire({
    title: title,
    allowOutsideClick: false,
  });
  return Swal.showLoading();
}
function closeAlert() {
  Swal.hideLoading();
  Swal.close();
}

function successAlert(title = "", text = "", timer = 1000) {
  return Swal.fire({
    position: "center",
    title: title,
    text: text,
    timer: timer,
    icon: "success",
    showConfirmButton: false,
  });
}

function timerAlert(
  title = "Auto close alert!",
  html = "I will close in <b></b> seconds.",
  timer = 2000,
  timerProgressBar = true,
  onCloseCallback = null
) {
  let timerInterval;
  return Swal.fire({
    title: title,
    html: html,
    timer: timer,
    timerProgressBar: timerProgressBar,
    didOpen: () => {
      Swal.showLoading();
      const timerElement = Swal.getPopup().querySelector("b");
      timerInterval = setInterval(() => {
        if (timerElement) {
          const timerLeftInSeconds = (Swal.getTimerLeft() / 1000).toFixed(1); // Convert milliseconds to seconds
          timerElement.textContent = `${timerLeftInSeconds}`;
        }
      }, 100);
    },
    willClose: () => {
      clearInterval(timerInterval);
      if (onCloseCallback && typeof onCloseCallback === "function") {
        onCloseCallback(); // Execute the callback when the alert closes
      }
    },
  }).then((result) => {
    if (result.dismiss === Swal.DismissReason.timer) {
      console.log("I was closed by the timer");
    }
  });
}
export default {
  transactionNotValidAlert,
  systemErrorAlert,
  fatalErrorAlert,
  apiErrorAlert,
  infoAlert,
  warningAlert,
  loadingAlert,
  errorAlert,
  hardErrorAlert,
  requestPinCodeErrorAlert,
  successAlert,
  shetabStartingAlert,
  transactionSuccessAlert,
  paymentIdNotValidAlert,
  closeAlert,
  timerAlert,
};
